import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon-taikai.png'


const _withScopeId = n => (_pushScopeId("data-v-e9a6e876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = {
  key: 0,
  class: "header-content"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-level" }, "大会スタッフ", -1))
const _hoisted_6 = { class: "nav" }
const _hoisted_7 = { class: "header-nav-list" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "大会", -1))
const _hoisted_11 = { class: "logout" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-signout icon" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text _pcDisp" }, "ログアウト", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "header-content"
}
const _hoisted_16 = { class: "service-logo" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-level" }, "大会スタッフ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "service-logo"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.HOST_PATH + 'assets/img/logo-scorebee.png',
                  alt: "",
                  class: "logo"
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            }),
            _hoisted_5,
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    "active-class": "-is-active",
                    class: _normalizeClass([{ '-is-active': _ctx.isEventPage }, "header-nav-card"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "header-logout-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, _hoisted_14)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", {
                src: _ctx.HOST_PATH + 'assets/img/logo-scorebee.png',
                alt: "",
                class: "logo"
              }, null, 8, _hoisted_17)
            ]),
            _hoisted_18
          ]))
    ])
  ]))
}